import dynamic from "next/dynamic";
import BasicButtonConfig from "./basic-button-config";
import BasicButtonAdvancedConfig from "./basic-button-advanced-config";
const BasicButtonComponent = dynamic(()=>import("./basic-button-component"));
export default {
    BasicButtonComponent,
    BasicButtonConfig,
    BasicButtonAdvancedConfig
};
